import React, { useEffect, useState, useContext } from "react";

import { Context as AuthContext } from "../context/auth.context";
import { Context as WalletContext } from "../context/wallet.context";

import { useMediaQuery } from "react-responsive";

import { Button, Modal } from "@material-ui/core";
import { Snackbar } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import CardIcon from "@material-ui/icons/CreditCard";
import BackIcon from "@material-ui/icons/ChevronLeft";
import { Context as PortalContext } from "../context/portal.context";
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import CircularProgress from "@material-ui/core/CircularProgress";

import AddCard from "../components/AddCard";
import AddAch from "../components/AddAch";

const AddPaymentType = (props) => {
  const [isChooseType, setIsChooseType] = useState(true);
  const portalState = useContext(PortalContext);
  const defaultCC = portalState.state.ccEnable

  const [isAddCard, setIsAddCard] = useState(defaultCC);
  const [snackOpen, setSnackOpen] = useState(false);
  

  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1000px)" });

  const authState = useContext(AuthContext);
  const { addPaymentMethod } = useContext(WalletContext);
  const walletState = useContext(WalletContext);

  useEffect(() => {
    console.log(props.wallet);
  }, []);

  const handleSnackClose = () => {
    setSnackOpen(false);
  };

  return (
    <div
      style={{
        ...styles.container,
        padding: isTabletOrMobile ? 15 : 30,
        background: isTabletOrMobile ? "white" : null,
      }}
    >
      <div>
        <div style={styles.typesContainer}>
          {portalState.state.ccEnable ? (
            <Button
              variant={isAddCard ? "outlined" : "text"}
              style={{ width: 175, marginRight: 15 }}
              onClick={() => {
                setIsChooseType(false);
                setIsAddCard(true);
              }}
              color="primary"
              startIcon={<CardIcon style={{ fontSize: 25 }} />}
            >
              <x-lang>Credit Card</x-lang>
            </Button>
          ) : null}
          {portalState.state.achEnable ? (
            <Button
              variant={!isAddCard ? "outlined" : "text"}
              style={styles.typeContainer}
              onClick={() => {
                setIsChooseType(false);
                setIsAddCard(false);
              }}
              color="primary"
              startIcon={<AccountBalanceIcon style={{ fontSize: 25 }} />}
            >
              <x-lang>Ach / E-check</x-lang>
            </Button>
          ) : null}
        </div>
        {isAddCard ? (
          <AddCard wallet={props.wallet} />
        ) : (
          <AddAch wallet={props.wallet} />
        )}
        {walletState.state.addingPayment ? (
          <div style={styles.loading}>
            <CircularProgress color="primary" />
          </div>
        ) : null}
      </div>
      <Modal
        open={walletState.state.addPaymentSuccess}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          outline: "none",
          overflow: "auto",
        }}
      >
        <div
          style={{
            background: "white",
            height: 200,
            width: 200,
            borderRadius: 10,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <x-lang>Payment Saved</x-lang>
        </div>
      </Modal>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",
    position: "relative",
    overflow: "auto",
  },
  typeContainer: {
    width: 175,
  },
  typesContainer: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    marginTop: 20,
    marginBottom: 40,
  },
  backButton: {
    position: "absolute",
    top: 25,
    left: 25,
  },
  loading: {
    position: "absolute",
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    background: "rgba(255, 255, 255, 0.7)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
};

export default AddPaymentType;
